import React, { useEffect } from "react";
import "../assets/css/AboutWychooseSection.css";
import visionImg from "../assets/images/skin-breadcrum.jpg";
import missionImg from "../assets/images/Our Story.jpg";
import researchIcon from "../assets/images/whyChoose-icon1.svg";
import scienceIcon from "../assets/images/whyChoose-icon2.svg";
import shieldIcon from "../assets/images/whyChoose-icon3.svg";
import dropletIcon from "../assets/images/whyChoose-icon4.svg";


const WhyChoose = () => {
    useEffect(() => {
        const elements = document.querySelectorAll("[data-animate]");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) entry.target.classList.add("animate");
                });
            },
            { threshold: 0.25 }
        );

        elements.forEach((el) => observer.observe(el));
        return () => elements.forEach((el) => observer.unobserve(el));
    }, []);

    return (
        <>
            {/* ---------- VISION SECTION ---------- */}
            <section className="vm-section">
                <div className="container">
                    <div className="row align-items-center">
                        {/* TEXT LEFT */}
                        <div className="col-md-6 vm-text" data-animate="slide-left">
                            <p className="vm-label">OUR APPROACH</p>
                            <h2 className="vm-title">Why Choose Biopharmacieaa?</h2>
                            <p className="vm-desc">
                                We combine innovation, research, and nature’s essence to develop high-performance formulations
                                that safeguard your health and vitality. Our therapies are customized to your unique requirements—ensuring
                                results you can trust and feel.
                            </p>

                            {/* Feature points: 4 items with PNG icons */}
                            <div className="feature-points" data-animate="fade-up">
                                <div className="fp-grid">

                                    <div className="fp-item">
                                        <span className="fp-icon">
                                            <img src={researchIcon} alt="Well Researched" />
                                        </span>
                                        <span className="fp-text">Well-Researched</span>
                                    </div>

                                    <div className="fp-item">
                                        <span className="fp-icon">
                                            <img src={scienceIcon} alt="Scientifically Advanced" />
                                        </span>
                                        <span className="fp-text">Scientifically Advanced</span>
                                    </div>

                                    <div className="fp-item">
                                        <span className="fp-icon">
                                            <img src={ shieldIcon } alt="Safe and Effective" />
                                        </span>
                                        <span className="fp-text">Safe and Effective</span>
                                    </div>

                                    <div className="fp-item">
                                        <span className="fp-icon">
                                            <img src={dropletIcon} alt="Essence of Nature" />
                                        </span>
                                        <span className="fp-text">Essence of Nature</span>
                                    </div>

                                </div>
                            </div>


                        </div>

                        {/* IMAGE RIGHT */}
                        <div className="col-md-6 text-center" data-animate="slide-right">
                            <img src={visionImg} alt="Our Vision" className="vm-image" />
                        </div>
                    </div>
                </div>

                {/* Decorative floating dots */}
                <span className="decor decor-1"></span>
                <span className="decor decor-2"></span>
            </section>

            {/* ---------- MISSION SECTION ---------- */}
            <section className="vm-section">
                <div className="container">
                    <div className="row align-items-center flex-md-row-reverse">
                        {/* TEXT RIGHT */}
                        <div className="col-md-6 vm-text" data-animate="slide-right">
                            <p className="vm-label">LEGACY</p>
                            <h2 className="vm-title">Embracing the Motto of Health & Wellness</h2>
                            <p className="vm-desc">
                                Established in 2019,  Biopharmacieaa was founded on a visionary goal — to set new milestones in the healthcare industry through innovative, high-quality solutions.
                                Over the years, we have emerged as one of the fastest-growing names in dermatology, guided by strong values and a commitment to improving lives through our distinctive formulations.
                            </p>
                        </div>

                        {/* IMAGE LEFT */}
                        <div className="col-md-6 text-center" data-animate="slide-left">
                            <img src={missionImg} alt="Our Mission" className="vm-image" />
                        </div>
                    </div>
                </div>

                {/* Decorative floating dots */}
                <span className="decor decor-3"></span>
                <span className="decor decor-4"></span>
            </section>
        </>
    );
};

export default WhyChoose;
